var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckHudge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check-hudge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M25,0A25,25,0,1,0,50,25,25.028,25.028,0,0,0,25,0Zm0,0",
    fill: "#00e52e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M163.267,168.6,150.82,181.043a1.913,1.913,0,0,1-2.707,0l-6.223-6.223a1.914,1.914,0,0,1,2.707-2.707l4.869,4.869,11.093-11.092a1.914,1.914,0,0,1,2.707,2.707Zm0,0",
    transform: "translate(-127.489 -148.811)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckHudge);
export default __webpack_public_path__ + "static/media/check-hudge.06ff7006598cdf4b24a4c532d2d60580.svg";
export { ForwardRef as ReactComponent };